import { createAsyncThunk } from '@reduxjs/toolkit';
import { callGetAPI, callPostAPI, callPutAPI } from '../../services/axios';

export const getMediciens = createAsyncThunk(
	'getMediciens',
	async(params, { rejectWithValue }) => {
		try {
			const { key, ...newParams } = params;
			const response = await callGetAPI({ route: `hospital/medicines?type=${key}`, params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const createMediciens = createAsyncThunk(
	'createMediciens',
	async(params, { rejectWithValue }) => {
		try {
			const response = await callPostAPI({ route: 'hospital/medicines', body: params });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getMedicienDetails = createAsyncThunk(
	'getMedicienDetails',
	async(params, { rejectWithValue }) => {
		try {
			const { id } = params;
			const response = await callGetAPI({ route: `hospital/medicines/${id}` });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const updateMediciens = createAsyncThunk(
	'updateMediciens',
	async(params, { rejectWithValue }) => {
		try {
			const { id, body } = params;
			const response = await callPutAPI({ route: `hospital/medicines/${id}`, body });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const approvalMediciens = createAsyncThunk(
	'approvalMediciens',
	async(params, { rejectWithValue }) => {
		try {
			const response = await callPostAPI({ route: 'hospital/medicines/approval', body: params });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);